module.exports = __webpack_public_path__ + "static/safari-bar-dark-ee61659983b5caaf5fa7c3007258c262.png";